import { Link } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';
import { authApi } from '@/api/client';

export function Header() {
  const user = useAuthStore((s) => s.user);
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated());
  const logout = useAuthStore((s) => s.logout);

  const handleLogout = async () => {
    try {
      await authApi.logout();
    } catch {
      // ignore — log out locally anyway
    }
    logout();
  };

  return (
    <header className="h-14 bg-white border-b border-gray-200 flex items-center px-4 justify-between z-20 relative">
      <Link to="/" className="flex items-center gap-2">
        <div className="w-8 h-8 bg-brand-600 rounded-lg flex items-center justify-center text-white font-bold">
          M
        </div>
        <span className="font-semibold text-gray-900">MyMap</span>
      </Link>

      <div className="flex items-center gap-3">
        {isAuthenticated && user ? (
          <div className="flex items-center gap-3">
            <Link
              to="/admin/projects"
              className="text-sm text-gray-600 hover:text-gray-900 hidden md:inline"
            >
              Đồ án
            </Link>
            {user.role === 'super_admin' && (
              <Link
                to="/admin"
                className="text-sm text-gray-600 hover:text-gray-900 hidden md:inline"
              >
                Quản trị
              </Link>
            )}
            <div className="hidden sm:flex flex-col items-end">
              <span className="text-sm font-medium text-gray-900">{user.name}</span>
              <span className="text-xs text-gray-500 capitalize">{user.role.replace('_', ' ')}</span>
            </div>
            <button
              onClick={handleLogout}
              className="text-sm text-gray-600 hover:text-gray-900"
            >
              Đăng xuất
            </button>
          </div>
        ) : (
          <div className="flex items-center gap-2">
            <Link
              to="/login"
              className="text-sm text-gray-700 hover:text-gray-900 px-3 py-1.5"
            >
              Đăng nhập
            </Link>
            <Link
              to="/register"
              className="text-sm bg-brand-600 text-white px-3 py-1.5 rounded-md hover:bg-brand-700"
            >
              Đăng ký
            </Link>
          </div>
        )}
      </div>
    </header>
  );
}
